export default function Contact() {
  const handleEmailClick = () => {
    window.location.href = 'mailto:techheroeshub@gmail.com';
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/2349132216166', '_blank');
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-[#004aad] via-[#003080] to-[#002060] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-64 h-64 border-4 border-white rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 border-4 border-white rotate-45"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 border-4 border-white rounded-full"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
          Ready to Scale Your Business?
        </h2>
        <p className="text-xl md:text-2xl text-[#ffbd59] mb-12 max-w-3xl mx-auto leading-relaxed">
          Let TechHeroesHub handle your sales, support, and marketing—so you can focus on what matters most.
        </p>

        <div className="mb-12">
          <button 
            onClick={handleEmailClick}
            className="bg-white text-gray-900 px-12 py-5 rounded-full text-xl font-bold hover:bg-teal-50 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
          >
            Contact Us Today
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>

        {/* Contact Cards */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 max-w-3xl mx-auto">
          <button
            onClick={handleEmailClick}
            className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 hover:bg-white/20 transition-all duration-300 cursor-pointer flex items-center gap-4 w-full sm:w-auto group"
          >
            <div className="w-12 h-12 rounded-full bg-[#ffbd59] flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <div className="text-left">
              <div className="text-[#ffbd59] text-sm font-medium">Email</div>
              <div className="text-white text-lg font-semibold">techheroeshub@gmail.com</div>
            </div>
          </button>

          <button
            onClick={handleWhatsAppClick}
            className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 hover:bg-white/20 transition-all duration-300 cursor-pointer flex items-center gap-4 w-full sm:w-auto group"
          >
            <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <i className="ri-whatsapp-line text-2xl text-white"></i>
            </div>
            <div className="text-left">
              <div className="text-[#ffbd59] text-sm font-medium">WhatsApp</div>
              <div className="text-white text-lg font-semibold">+234 913 221 6166</div>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}